import { useEffect, useState } from "react";
import { fetchRawCatalogData } from "../services/catalogService";

export interface WorkshopVisibility {
  isVisible: boolean;
  isLoading: boolean;
}

const isAvailable = (row: any): boolean => {
  if (!row) return false;
  if (row.Disponible === undefined || row.Disponible === null) return true;
  if (row.Disponible === false || row.Disponible === 0) return false;
  return !["false", "0"].includes(String(row.Disponible).trim().toLowerCase());
};

export const useWorkshopVisibility = (enabled = true): WorkshopVisibility => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) {
      setIsVisible(false);
      setIsLoading(false);
      return;
    }

    let active = true;
    setIsLoading(true);

    fetchRawCatalogData()
      .then((rows) => {
        if (!active) return;
        const workshopRow = rows.find((row: any) => row.ID === "config_workshop");
        setIsVisible(Boolean(workshopRow && isAvailable(workshopRow)));
      })
      .catch(() => {
        if (active) setIsVisible(false);
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, [enabled]);

  return { isVisible, isLoading };
};
